import React, { useState } from 'react';
import ClubAutocomplete from './controls/ClubAutocomplete';
const ROLES = ['Swimmer', 'Parent', 'Coach', 'Other'];
const ProfileOnboardingModal = ({ onSave, onSkip }) => {
    const [homeClub, setHomeClub] = useState('');
    const [role, setRole] = useState('');
    const [saving, setSaving] = useState(false);
    const canSave = homeClub.trim().length > 0 && role !== '';
    const handleSave = async () => {
        if (!canSave || saving)
            return;
        setSaving(true);
        try {
            await onSave({ homeClub: homeClub.trim(), role: role });
        }
        finally {
            setSaving(false);
        }
    };
    return (React.createElement("div", { className: "modal-backdrop" },
        React.createElement("div", { className: "modal", onClick: e => e.stopPropagation() },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h3", null, "Tell us about yourself")),
            React.createElement("div", { className: "modal-body" },
                React.createElement("p", { className: "pending-load-note" }, "This helps us personalise Swim Lab for you. You can change these later in your profile."),
                React.createElement("label", { className: "pending-load-field" },
                    React.createElement("span", null, "Home Club"),
                    React.createElement(ClubAutocomplete, { value: homeClub, onChange: setHomeClub, placeholder: "Start typing your club name", autoFocus: true })),
                React.createElement("label", { className: "pending-load-field" },
                    React.createElement("span", null, "I am a..."),
                    React.createElement("select", { value: role, onChange: e => setRole(e.target.value) },
                        React.createElement("option", { value: "", disabled: true }, "Select a role"),
                        ROLES.map(r => (React.createElement("option", { key: r, value: r }, r)))))),
            React.createElement("div", { className: "modal-actions" },
                React.createElement("button", { type: "button", className: "btn", style: { opacity: 0.8 }, onClick: onSkip, disabled: saving }, "Skip for now"),
                React.createElement("button", { type: "button", className: "btn", onClick: handleSave, disabled: !canSave || saving }, saving ? 'Saving...' : 'Save')))));
};
export default ProfileOnboardingModal;
